// Getters (GET*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const FILTERS_GET_CATEGORIES = 'FILTERS_GET_CATEGORIES';
export const FILTERS_GET_CURRENT_CATEGORY = 'FILTERS_GET_CURRENT_CATEGORY';
export const FILTERS_GET_CURRENT_GROUP = 'FILTERS_GET_CURRENT_GROUP';
export const FILTERS_GET_DATA = 'FILTERS_GET_DATA';
export const FILTERS_GET_ID = 'FILTERS_GET_ID';
export const FILTERS_GET_PARAMS = 'FILTERS_GET_PARAMS';
export const FILTERS_GET_STATE = 'FILTERS_GET_STATE';
export const FILTERS_GET_VALUES = 'FILTERS_GET_VALUES';
export const FILTERS_GET_EXPORT = 'FILTERS_GET_EXPORT';

// Mutations (SET*, ADD*, REMOVE*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const FILTERS_SET_CURRENT_CATEGORY = 'FILTERS_SET_CURRENT_CATEGORY';
export const FILTERS_SET_CURRENT_GROUP = 'FILTERS_SET_CURRENT_GROUP';
export const FILTERS_SET_STATE = 'FILTERS_SET_STATE';
export const FILTERS_SET_VALUES = 'FILTERS_SET_VALUES';

// Actions (FETCH*, CREATE*, UPDATE*, DELETE*, ANY*)
// [CONTEXT]_[ACTION]_[PROPERTY]_[STATUS]
export const FILTERS_RESET = 'FILTERS_RESET';
export const FILTERS_UPDATE_CURRENT_CATEGORY = 'FILTERS_UPDATE_CURRENT_CATEGORY';
export const FILTERS_UPDATE_CURRENT_GROUP = 'FILTERS_UPDATE_CURRENT_GROUP';
export const FILTERS_UPDATE_DATA = 'FILTERS_UPDATE_DATA';
export const FILTERS_UPDATE_VALUES = 'FILTERS_UPDATE_VALUES';
